import { render, staticRenderFns } from "./ModalEditLocationLegal.vue?vue&type=template&id=cf2821fa"
import script from "./ModalEditLocationLegal.vue?vue&type=script&lang=js"
export * from "./ModalEditLocationLegal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports